import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  showCategory?: boolean;
  showDescription?: boolean;
}

export default function ComicCard({ comic, showCategory = true, showDescription = false }: ComicCardProps) {
  const viewsText = comic.views >= 10000
    ? `${(comic.views / 10000).toFixed(1)}万`
    : comic.views.toString();

  return (
    <article className="group" data-product-shop>
      <Link to={`/comic/${comic.slug}`} className="block cursor-pointer">
        <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
          <img
            src={comic.cover}
            alt={`${comic.title}漫画封面`}
            title={`${comic.title} - 叮当漫画网免费阅读`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
            <span className="px-5 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-full whitespace-nowrap">
              立即阅读
            </span>
          </div>
          <div className="absolute top-2 left-2 flex flex-col gap-1">
            {comic.isHot && (
              <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                HOT
              </span>
            )}
            {comic.isNew && (
              <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                NEW
              </span>
            )}
          </div>
          {comic.status === '已完结' && (
            <div className="absolute top-2 right-2 px-2 py-0.5 bg-foreground-800/80 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
              已完结
            </div>
          )}
        </div>

        <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>

        {showDescription && (
          <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
            {comic.description}
          </p>
        )}

        <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-400">
          {showCategory && (
            <span className="px-1.5 py-0.5 bg-secondary-100 text-secondary-700 rounded whitespace-nowrap">
              {comic.category}
            </span>
          )}
          <span className="flex items-center gap-1">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-eye-line text-[10px]"></i>
            </span>
            {viewsText}
          </span>
          <span className="flex items-center gap-1">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-[10px] text-accent-500"></i>
            </span>
            {comic.rating}
          </span>
        </div>
      </Link>
    </article>
  );
}